module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_8_m.17303c48e72a7d625b0a21e1039e63cf.png";